<template>
  <div :id="id" class="basics-chart-main"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "basicsChart",
  props: {
    option: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      myChart: null,
      listener: null,
    };
  },
  mounted() {
    const chartDom = document.getElementById(this.id);
    this.myChart = echarts.init(chartDom);
    this.listener = () => {
      console.log("echart.resize");
      this.myChart.resize();
    };
    window.addEventListener("resize", this.listener);
    window.addEventListener("setItem", this.listener);
    this.$nextTick(() => {
      this.myChart.resize();
      this.myChart.on("contextmenu", this.onContextmenu);
      this.myChart.on("click", this.onClick);
    });
  },
  methods: {
    updateChart() {
      this.$nextTick(() => {
        this.option && this.myChart.setOption(this.option, true);
        // 防止从别的页面切回来时,容器高度不对导致无法显示统计图, 手动调用resize
        this.myChart.resize();
      });
    },
    showLoading() {
      this.myChart.showLoading("default", {
        textColor: "#fff",
        maskColor: "rgba(255, 255, 255, 0)",
      });
    },
    hideLoading() {
      this.myChart.hideLoading();
    },
    onContextmenu(params) {
      document.getElementById(this.id).oncontextmenu = function (e) {
        console.log(e);
        return false;
      };
      this.$emit("onContextmenu", params);
    },
    onClick(params) {
      this.$emit("onClick", params);
    },
    getImg() {
      let img = new Image();
      img.src = this.myChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: "#081D43",
      });
      console.log(img);
    },
  },
  destroyed() {
    this.listener && window.removeEventListener("resize", this.listener);
  },
  deactivated() {
    this.listener && window.removeEventListener("resize", this.listener);
  },
};
</script>

<style>
.basics-chart-main {
  height: 100%;
  width: 100%;
}
</style>
